"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("./bea/store");
var store_2 = require("./planning/store");
exports.default = {
    namespaced: true,
    modules: {
        bea: store_1.default,
        planning: store_2.default
    }
};
//# sourceMappingURL=store.js.map